export default {
  xs: 0, // or 320px
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};
